// 视图组件
const view = {
  tabs: () => import('@/layouts/tabs'),
  blank: () => import('@/layouts/BlankView'),
  page: () => import('@/layouts/PageView'),
}

// 路由组件注册
const routerMap = {
  RouteView: {
    component: () => import('@/layouts/RouteView.vue'),
    meta: {
      menu: true,
    },
  },

  updateMechanism: {
    name: '编辑/添加机构',
    component: () => import('@/pages/projectImpl/orgManage/addProject.vue'),
  },
  login: {
    authority: '*',
    path: '/login',
    component: () => import('@/pages/login'),
  },
  jump: {
    authority: '*',
    path: '/jump',
    component: () => import('@/pages/jump'),
  },
  root: {
    path: '/',
    name: '首页',
    authority: '*',
    redirect: '/index/Workplace',
    component: view.tabs,
  },
  // 系统配置
  systemConfig: {
    name: '系统配置',
    component: view.page,
  },
  AutoReply: {
    name: '自动回复',
    component: () => import('@/pages/systemConfig/autoReply/AutoReply.vue'),
  },
  CustomMenu: {
    name: '自定义菜单',
    component: () => import('@/pages/systemConfig/customMenu/CustomMenu.vue'),
  },
  BrainMachine: {
    name: '脑机设备',
    component: () => import('@/pages/systemConfig/brainMachine/BrainMachine.vue'),
  },
  SpecialBrainMachine: {
    name: '新脑机设备',
    component: () => import('@/pages/systemConfig/brainMachine/SpecialBrainMachine.vue'),
  },
  BrainGames: {
    name: '脑机游戏',
    component: () => import('@/pages/systemConfig/brainGames/BrainGames.vue'),
  },
  SpecialBrainGames: {
    name: '新脑机游戏',
    component: () => import('@/pages/systemConfig/brainGames/SpecialBrainGames.vue'),
  },
  // 系统日志
  SysLog: {
    name: '系统日志',
    component: view.page,
  },
  SysLogOperation: {
    name: '操作日志',
    component: () => import('@/pages/systemConfig/sysLog/Operation.vue'),
  },
  SysLogException: {
    name: '异常日志',
    component: () => import('@/pages/systemConfig/sysLog/Exception.vue'),
  },
  SysLogRequest: {
    name: '请求日志',
    component: () => import('@/pages/systemConfig/sysLog/Request.vue'),
  },
  SysLogSystem: {
    name: '系统日志',
    component: () => import('@/pages/systemConfig/sysLog/System.vue'),
  },
  // 个人中心
  userCenter: {
    name: '个人中心',
    component: view.page,
  },
  userIndex: {
    name: '个人中心设置',
    component: () => import('@/pages/userCenter/userIndex'),
  },
  // 系统首页
  index: {
    name: '系统首页',
    component: view.page,
  },
  Workplace: {
    name: '工作台',
    component: () => import('@/pages/index/workplace'),
  },
  Analysis: {
    name: '分析页',
    component: () => import('@/pages/index/analysis'),
  },
  AreaScreen: {
    name: '平台大屏',
    blank: true, // 打开新窗口
    component: () => import('@/pages/index/areaScreen'),
  },
  // 运营中心
  operate: {
    // name: '运营中心',
    component: view.page,
  },
  ParamsSetting: {
    name: '参数配置',
    component: () => import('@/pages/settings/parasmSetting/index.vue'),
  },
  GoodsManage: {
    name: '商品管理',
    component: () => import('@/pages/operate/goodsManage/GoodsManage'),
  },
  GoodsDetail: {
    name: '商品详情',
    component: () => import('@/pages/operate/goodsDetail/GoodsDetail'),
  },
  UserManage: {
    name: '用户管理',
    component: () => import('@/pages/operate/userManage/UserManage'),
  },
  UserDetail: {
    name: '用户详情',
    component: () => import('@/pages/operate/userDetail/UserDetail'),
  },
  OrderManage: {
    name: '订单管理',
    component: () => import('@/pages/operate/orderManage/OrderManage'),
  },
  OrderDetail: {
    name: '订单详情',
    component: () => import('@/pages/operate/orderDetail/OrderDetail'),
  },
  FreeEvaluation: {
    name: '免费测评',
    component: () => import('@/pages/operate/freeEvaluation/FreeEvaluation'),
  },
  ProjectSeting: {
    name: '项目配置',
    component: () => import('@/pages/operate/projectSeting/ProjectSeting'),
  },
  ExperienceCourse: {
    name: '体验课配置',
    component: () => import('@/pages/operate/experienceCourse/ExperienceCourse'),
  },
  ChannelDispose: {
    name: '渠道配置',
    component: () => import('@/pages/operate/channel/ChannelDispose.vue'),
  },
  FreeEvaluationDetail: {
    name: '项目详情',
    component: () => import('@/pages/operate/freeEvaluation/FreeEvaluationDetail.vue'),
  },
  FreeEvaluationChannel: {
    name: '渠道链接',
    component: () => import('@/pages/operate/freeEvaluation/FreeEvaluationChannel.vue'),
  },
  LookCourseDetail: {
    name: '课程详情',
    component: () => import('@/pages/operate/experienceCourse/LookCourseDetail.vue'),
  },

  // 内容管理
  content: {
    name: '内容管理',
    component: view.page,
  },
  AlgorithmSeting: {
    name: '推荐算分配置',
    component: () => import('@/pages/content/algorithmSeting/AlgorithmSeting'),
  },
  Calculatecode: {
    name: '算分码管理',
    component: () => import('@/pages/content/calculatecode/Calculatecode'),
  },
  Editcalculatecode: {
    name: '算分码配置',
    component: () => import('@/pages/content/editcalculatecode/Editcalculatecode'),
  },
  Evaluationgame: {
    name: '测评游戏管理',
    component: () => import('@/pages/content/evaluationgame/Evaluationgame'),
  },

  BusinessEvaluation: {
    name: '商用测评',
    component: () => import('@/pages/content/businessEvaluation/BusinessEvaluation'),
  },
  ScienceEvaluation: {
    name: '科研测评',
    component: () => import('@/pages/content/scienceEvaluation/ScienceEvaluation'),
  },
  Statistics: {
    name: '统计详情',
    component: () => import('@/pages/content/statistics/Statistics'),
  },

  EvaluationgameSeting: {
    name: '测评游戏配置',
    component: () => import('@/pages/content/evaluationgameSeting/EvaluationgameSeting'),
  },
  Traingame: {
    name: '训练游戏管理',
    component: () => import('@/pages/content/traingame/Traingame'),
  },
  TraingameSeting: {
    name: '训练游戏配置',
    component: () => import('@/pages/content/traingameSeting/TraingameSeting'),
  },
  LevelSeting: {
    name: '关卡配置',
    component: () => import('@/pages/content/levelSeting/LevelSeting'),
  },
  MatchSeting: {
    name: '匹配设置',
    component: () => import('@/pages/content/matchSeting/MatchSeting'),
  },
  Questiongroup: {
    name: '题目壳管理',
    component: () => import('@/pages/content/questiongroup/Questiongroup'),
  },
  QuestionnaireManage: {
    name: '问卷管理',
    component: () => import('@/pages/content/questionnaireManage/QuestionnaireManage'),
  },
  QuestionnaireSeting: {
    name: '问卷配置',
    component: () => import('@/pages/content/questionnaireSet/QuestionnaireSeting'),
  },
  ParentingGame: {
    name: '亲子游戏管理',
    component: () => import('@/pages/content/questiongroup/Questiongroup'),
  },
  ParentingGameStting: {
    name: '亲子游戏配置',
    component: () => import('@/pages/content/questiongroupSeting/QuestiongroupSeting'),
  },
  QuestiongroupSeting: {
    name: '题目壳配置',
    component: () => import('@/pages/content/questiongroupSeting/QuestiongroupSeting'),
  },
  Questiongrouptemplate: {
    name: '题目壳模板',
    component: () => import('@/pages/content/questiongrouptemplate/Questiongrouptemplate'),
  },
  NormSeting: {
    name: '常模配置',
    component: () => import('@/pages/content/normSeting/NormSeting'),
  },
  NormComputeSet: {
    name: '常模计算配置',
    component: () => import('@/pages/content/normSeting/components/NormComputeSet'),
  },
  NormComputeDetail: {
    name: '常模计算配置详情',
    component: () => import('@/pages/content/normSeting/components/NormComputeDetail'),
  },
  CourseVideo: {
    name: '课程视频',
    component: () => import('@/pages/content/courseVideo/CourseVideo'),
  },
  CourseVideoSeting: {
    name: '课程视频配置',
    component: () => import('@/pages/content/courseVideoSeting/CourseVideoSeting'),
  },

  Dicability: {
    name: '能力维度',
    component: () => import('@/pages/content/dicability/Dicability'),
  },
  Question: {
    name: '题目管理',
    component: () => import('@/pages/content/question/Question'),
  },
  QuestionSeting: {
    name: '题目配置',
    component: () => import('@/pages/content/questionSeting/QuestionSeting'),
  },

  ContentProductService: {
    name: '产品服务',
    component: () => import('@/pages/content/productService/ProductService'),
  },
  ProductServiceSeting: {
    name: '产品服务配置',
    component: () => import('@/pages/content/productServiceSeting/ProductServiceSeting'),
  },
  ResourcesCenter: {
    name: '资源中心',
    component: () => import('@/pages/content/resourcesCenter/index.vue'),
  },
  MarketResourceView: {
    name: '公共资源',
    component: () => import('@/pages/content/marketResource/index.vue'),
  },
  MarketResource: {
    name: '公共资源',
    component: () => import('@/pages/content/marketResource/marketResource.vue'),
  },
  GamesComment: {
    name: '游戏评价',
    component: () => import('@/pages/content/gamesComment/index.vue'),
  },
  ViewRecord: {
    name: '查看评价',
    component: () => import('@/pages/content/gamesComment/components/ViewRecord'),
  },
  EditQuestion: {
    name: '编辑题目',
    component: () => import('@/pages/content/gamesComment/components/EditQuestion'),
  },
  BlackListSet: {
    name: '编辑添加黑名单',
    component: () => import('@/pages/content/gamesComment/components/BlackListSet'),
  },

  // 学情配置
  pupil: {
    name: '学情配置',
    component: view.page,
  },
  Learning: {
    name: '学业学习力权重',
    component: () => import('@/pages/pupil/learning/Learning'),
  },
  SubjectFullcredit: {
    name: '学科及满分',
    component: () => import('@/pages/pupil/subjectFullcredit/SubjectFullcredit'),
  },
  TotalScore: {
    name: '总分学科构成',
    component: () => import('@/pages/pupil/totalScore/TotalScore'),
  },
  Potential: {
    name: '学业潜能权重',
    component: () => import('@/pages/pupil/potential/Potential'),
  },
  // 权限管理
  settings: {
    name: '权限管理',
    component: view.page,
  },
  Roles: {
    name: '系统角色',
    component: () => import('@/pages/settings/roles/Roles'),
  },
  dataAuthority: {
    name: '数据权限',
    component: () => import('@/pages/settings/roles/child/dataAuthority'),
  },
  Adminuser: {
    name: '系统用户',
    component: () => import('@/pages/settings/adminuser/Adminuser'),
  },
  Apply: {
    name: '系统应用',
    component: () => import('@/pages/settings/apply/Apply'),
  },
  Sysapplicationmodule: {
    name: '系统模块',
    component: () => import('@/pages/settings/sysapplicationmodule/SystemModule.vue'),
    meta: {
      invisible: true,
    },
  },
  Deploy: {
    name: '权限配置',
    component: () => import('@/pages/settings/deploy/Deploy'),
    meta: {
      invisible: true,
    },
  },

  // 异常页
  exception: {
    name: '异常页',
    icon: 'warning',
    component: view.blank,
  },
  exp403: {
    authority: '*',
    name: 'exp403',
    path: '403',
    component: () => import('@/pages/exception/403'),
  },
  exp404: {
    name: 'exp404',
    path: '404',
    component: () => import('@/pages/exception/404'),
  },
  exp500: {
    name: 'exp500',
    path: '500',
    component: () => import('@/pages/exception/500'),
  },
}

// 课程中心
const CourseCenter = {
  CourseCenter: {
    name: '课程中心',
    component: view.page,
  },

  CourseCenterCourseManage: {
    name: '课程管理',
    component: () => import('@/pages/content/course/Course'),
  },
  ContentList: {
    name: '内容列表',
    component: () => import('@/pages/content/course/contentList/ContentList'),
  },
  CourseSeting: {
    name: '课程配置',
    component: () => import('@/pages/content/courseSeting/CourseSeting'),
  },
  CourseReport: {
    name: '课程报告',
    component: () => import('@/pages/content/courseSeting/components/Report'),
  },
  CourseChildren: {
    name: '课时列表',
    component: () => import('@/pages/content/courseSeting/components/CourseChildren'),
  },
  EvaluateContent: {
    name: '综合评价',
    component: () => import('@/pages/content/courseSeting/components/EvaluateContent'),
  },
  ChildrenCourseContent: {
    name: '课时内容配置',
    component: () => import('@/pages/content/childrenCourseContent/ChildrenCourseContent'),
  },

  CourseCenterCourseResources: {
    name: '课程资源',
    component: () => import('@/pages/content/courseResource/index.vue'),
  },
  CourseCenterCourseResourcesDetail: {
    name: '课程资源详情',
    component: () => import('@/pages/content/courseResource/detail.vue'),
  },
  CourseCenterCourseResourcesAE: {
    name: '课程资源添加/编辑',
    component: () => import('@/pages/content/courseResource/add.vue'),
  },
}

//项目实施
const ProjectImplementation = {
  projectImpl: {
    name: '项目实施',
    component: view.page,
  },
  pMechanism: {
    name: '机构管理',
    component: () => import('@/pages/projectImpl/orgManage/orgList.vue'),
  },
  AdminStatistic: {
    name: '数据统计',
    component: () => import('@/pages/projectImpl/orgManage/adminStatistic.vue'),
  },
  organizationDetails: {
    name: '机构详情',
    component: () => import('@/pages/projectImpl/orgManage/orgDetails.vue'),
  },
  StudentsManage: {
    name: '学生管理',
    component: () => import('@/pages/projectImpl/studentsManage/index.vue'),
  },
  CourseManage: {
    name: '课程管理',
    component: () => import('@/pages/projectImpl/courseManage/courseList.vue'),
  },
  CourseManageDetails: {
    name: '课程详情',
    component: () => import('@/pages/projectImpl/courseManage/courseDetails.vue'),
  },

  areaProjectSet: {
    name: '区域项目设置',
    component: () => import('@/pages/projectImpl/orgManage/childPages/AreaProjectSet.vue'),
  },

  CourseManageCourseList: {
    name: '课程详情',
    component: () => import('@/pages/projectImpl/courseManage/childPages/CourseDetails.vue'),
  },
  CourseManageUserCourse: {
    name: '用户课程',
    component: () => import('@/pages/projectImpl/courseManage/childPages/UserCourse.vue'),
  },
  CourseManageUserHour: {
    name: '用户课时',
    component: () => import('@/pages/projectImpl/courseManage/childPages/UserClassHour.vue'),
  },
  addCourse: {
    name: '添加课程',
    component: () => import('@/pages/projectImpl/courseManage/childPages/AddOrEditCourse.vue'),
  },

  courseHourResource: {
    name: '课时资源',
    component: () => import('@/pages/projectImpl/orgManage/childPages/courseHourResource.vue'),
  },
  courseHourResourceContent: {
    name: '查看内容',
    component: () => import('@/pages/projectImpl/orgManage/childPages/courseHourResourceContent.vue'),
  },
  TeachResourceDetails: {
    name: '资源包详情',
    component: () => import('@/pages/projectImpl/orgManage/childPages/TeachResourceDetails.vue'),
  },
  pStudentDetails: {
    name: '用户详情',
    component: () => import('@/pages/projectImpl/studentsManage/StudentDetails.vue'),
  },
}

//报告中心
const ReportCenter = {
  reportCenter: {
    name: '报告中心',
    component: view.page,
  },
  templateManage: {
    name: '模板管理',
    component: () => import('@/pages/reportCenter/templateManage/TemplateManage.vue'),
  },
  abilityEvaluate: {
    name: '能力评价',
    component: () => import('@/pages/reportCenter/abilityEvaluate/AbilityEvaluate.vue'),
  },
  abilitySystem: {
    name: '能力体系',
    component: () => import('@/pages/reportCenter/abilitySystem/AbilitySystem.vue'),
  },
  groupReport: {
    name: '团体测评报告',
    component: () => import('@/pages/reportCenter/groupReport/GroupReport.vue'),
  },
  groupReportNew: {
    name: '团体测评报告',
    component: () => import('@/pages/reportCenter/groupReport_new/GroupReport.vue'),
  },
  GroupTrainingReport: {
    name: '团体训练报告',
    component: () => import('@/pages/reportCenter/groupTrainingReport/GroupTrainingReport.vue'),
  },
  ReportDataTemp: {
    name: '数据模板',
    component: () => import('@/pages/settings/groupSetting/dataTemp/index.vue'),
  },
  AddDataTemp: {
    name: '新增数据模板',
    component: () => import('@/pages/settings/groupSetting/dataTemp/AddTemp/index.vue'),
  },
  personalReport: {
    name: '团体报告',
    component: () => import('@/pages/reportCenter/personalReport/PersonalReport.vue'),
  },
  GradeManagement: {
    name: '成绩管理',
    component: () => import('@/pages/projectImpl/grademanage/index.vue'),
  },
}

export default {
  ...routerMap,
  ...ProjectImplementation,
  ...ReportCenter,
  ...CourseCenter,
}
